import { IPhone } from '../types/developer/contacts';
import { isCorrectPhoneObject } from './isCorrectPhoneObject';

export function phoneToString(phone?: IPhone | null) {
  if (phone && isCorrectPhoneObject(phone)) {
    return `${phone.countryCode}${phone.code}${phone.number}`;
  }

  return '';
}
